<div class="item" *ngFor="let item of items | slice: 0 : visibleItems; trackBy: trackByIndex">
  <ng-container [ngTemplateOutlet]="listItemTemplate" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
</div>
<ng-container *ngIf="(items?.length || 0) > visibleItems">
  <ng-container *ngIf="showMore">
    <div class="item" *ngFor="let item of items | slice: visibleItems; trackBy: trackByIndex">
      <ng-container [ngTemplateOutlet]="listItemTemplate" [ngTemplateOutletContext]="{ $implicit: item }">
      </ng-container>
    </div>
  </ng-container>
  <div class="flex-row flex-place-content-center">
    <button (click)="onToggleShowMore()" data-testid="showMoreButton" color="primary" mat-button>
      <ng-container *ngIf="!showMore; else showLess">{{ viewMoreLabel }}</ng-container>
      <ng-template #showLess>{{ viewLessLabel }}</ng-template>
    </button>
  </div>
</ng-container>
